import React, { Component } from "react";
import { connect } from "react-redux";
import { selectFlight, unselectFlight } from "../actions";
import {
	saleTotalPerPassengerType,
	formatCurrency,
	feesTranslations,
	bestMaxMilhasPrice,
	defineFlightCabin
} from "../shared/utils";
import FlightStretch from "./FlightStretch";
import FlightResume from "./FlightResume";
import FlightsInterval from "./FlightsInterval";
import FormatedCurrency from "./FormatedCurrency";
import DispatchLuggage from "./DispatchLuggage";
import Popover from "./Popover";
import { isValid } from "../shared/utils";
import { getFlightDetails } from "../shared/requests-api";
import PriceCampaing from "./FlighRowPriceCampaing";
import { Tooltip } from "react-tippy";

class FlightRow extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showFlightDetails: false,
			showUnselectButton: false
		};
	}

	componentWillMount() {
		if (this.props.isSelectedFlight)
			this.setState({ showFlightDetails: true, showUnselectButton: true });
	}

	toggleFlightDetails(event) {
		event.preventDefault();

		if (
			this.props.flightdata.airline === "starAlliance" &&
			this.props.flightdata.pricing.mmBestPriceAt === "miles" &&
			(this.props.flightdata.pricing.miles.provider === "amigo" ||
				this.props.flightdata.pricing.miles.provider === "star_alliance") &&
			this.props.flightdata.updated !== true
		) {
			this.setState(prevState => ({ showFlightDetails: !prevState.showFlightDetails }));
			this.props.getFlightDetail(
				[this.props.flightdata.id],
				this.props.searchId,
				this.props.selectedFlights,
				this.props.flightdata.direction
			);
		}

		this.setState(prevState => ({ showFlightDetails: !prevState.showFlightDetails }));
	}

	showFlightResume() {
		if (this.state.showFlightDetails) return <FlightResume flightdata={this.props.flightdata} />;
	}

	listingPassengers(pricing) {
		let list = [];
		let total = 0;
		let fare = 0;

		const passengersType = {
			adult: "Adulto",
			child: "Criança",
			infant: "Bebê"
		};

		Object.keys(pricing).forEach(item => {
			if (["adult", "child", "infant"].indexOf(item) > -1) {
				fare += pricing[item].fare * pricing[item].quantity;
				total += pricing[item].quantity;
				list.push({
					key: `${pricing[item].quantity} ${passengersType[item]}${
						pricing[item].quantity > 1 ? "s" : ""
					}`,
					value: pricing[item].fare * pricing[item].quantity
				});
			}
		});

		return { total, fare, list };
	}

	listingFees(pricing) {
		let list = [];
		let taxes = {};
		let total = 0;

		Object.keys(pricing).forEach(item => {
			if (["adult", "child", "infant"].indexOf(item) > -1 && pricing[item]) {
				pricing[item].fees &&
					pricing[item].fees.forEach(fee => {
						if (!taxes[fee.type]) taxes[fee.type] = 0;
						taxes[fee.type] += fee.value * pricing[item].quantity;
						total += fee.value * pricing[item].quantity;
					});
			}
		});

		list.push({ key: "Taxas e encargos", value: total });

		return { total, list };
	}

	renderCiaPrice() {
		const { airline, airlineTarget, otaAvailableIn: availableIn, pricing } = this.props.flightdata;

		if (availableIn === "both") {
			const maxPrice = bestMaxMilhasPrice(pricing);

			const maxBoardingTax = maxPrice.adult.fees.find(tax => {
				return tax.type === "BOARDING_TAX";
			});

			let airlineAdultPrice = saleTotalPerPassengerType(pricing.airline.adult);

			if (isValid(maxBoardingTax) === false) {
				const airlineBoardingTax = pricing.airline.adult.fees.find(tax => {
					return tax.type === "BOARDING_TAX";
				});

				if (isValid(airlineBoardingTax)) {
					airlineAdultPrice -= airlineBoardingTax.value;
				}
			}

			return (
				<div className="cia-price">
					<span>Na {airline.toUpperCase()} </span>
					<span className={pricing.bestPriceAt === "airline" ? "" : "line-through"}>
						<FormatedCurrency value={airlineAdultPrice} />
					</span>
				</div>
			);
		} else {
			let info;

			if (availableIn === "maxmilhas") {
				if (airlineTarget === "others") {
					info = "Disponível MaxMilhas";
				} else {
					info = "Exclusivo na MaxMilhas";
				}
			} else if (availableIn === "airline") {
				info = "Exclusivo na cia aérea";
			}

			return (
				<div className="exclusive">
					<span>{info}</span>
				</div>
			);
		}
	}

	renderHighlightPrice() {
		const {
			id,
			direction,
			pricing,
			otaAvailableIn: availableIn,
		} = this.props.flightdata;

		const stretch = direction === "outbound" ? "Ida" : "Volta";
		const savings = pricing.savingPercentage > 0 ? Math.floor(pricing.savingPercentage) : null;

		let highlightPrice, airlinePrice, listPassengers, listFees;

		if (availableIn === "airline") {
			highlightPrice = saleTotalPerPassengerType(pricing.airline.adult);
			listPassengers = this.listingPassengers(pricing.airline);
			listFees = this.listingFees(pricing.airline);
		} else {
			const maxPrice = bestMaxMilhasPrice(pricing);

			highlightPrice = saleTotalPerPassengerType(maxPrice.adult);
			listPassengers = this.listingPassengers(maxPrice);
			listFees = this.listingFees(maxPrice);

			if (availableIn === "both") {
				airlinePrice = saleTotalPerPassengerType(pricing.airline.adult);
			}
		}

		const withoutAllFees = listFees.list.find(obj => obj.value === null) !== undefined;

		return (
			<div className="highlight-price">
				<div className={`price ${listPassengers.total > 1 ? "price--small" : ""} `}>
					<span id={`tooltip-flight-${id}`}>
						{formatCurrency(highlightPrice)}
						{listPassengers.total === 1 && (
							<span>
								<Tooltip
									tabIndex={"0"}
									html={<Popover listas={[listPassengers.list, listFees.list]} />}
									position="top"
									arrow={true}
									onShow={() => {
										const tooltip = document.querySelector(`#tooltip-flight-${id}`);
										tooltip.setAttribute("data-action", `search-result-total-${direction}`);
									}}
								>
									<i className="tooltip">?</i>
								</Tooltip>
							</span>
						)}
					</span>
					<span className="small">
						{this.props.searchParams.tripType === "RT" ? `${stretch} por` : "Por"} adulto{" "}
						{withoutAllFees ? "sem" : "com"} taxas {availableIn === "both" && "na MaxMilhas"}
					</span>
				</div>
				{listPassengers.total > 1 && (
					<div className="values-block">
						<div className="value-line">
							<span id={`tooltip-flight-${id}`}>
								Valor total{this.props.searchParams.tripType === "RT"
									? ` do voo de ${stretch.toLowerCase()}`
									: ""}
								<Tooltip
									tabIndex={"0"}
									html={<Popover listas={[listPassengers.list, listFees.list]} />}
									position="top"
									arrow={true}
									onShow={() => {
										const tooltip = document.querySelector(`#tooltip-flight-${id}`);
										tooltip.setAttribute("data-action", `search-result-total-${direction}`);
									}}
								>
									<i className="tooltip">?</i>
								</Tooltip>
							</span>
							<span>{formatCurrency(listPassengers.fare + listFees.total)}</span>
						</div>
					</div>
				)}
				<div
					className="savings-tag-wrapper"
					data-action={
						this.props.searchParams.tripType === "RT"
							? `flight-buy-${direction}`
							: "flight-buy-one-way"
					}
				>
					<button
						className={`btn btn-success ${
							savings || (airlinePrice && Math.round(airlinePrice) === Math.round(highlightPrice))
								? "btn--tag-margin"
								: ""
						}`}
						onClick={() => {
							this.props.selectFlight(
								this.props.flightdata,
								this.props.searchId,
								this.props.selectedFlights
							);
							window.scrollTo(0, 0);
						}}
					>
						<span className="buy">Comprar</span>
					</button>

					{airlinePrice && Math.round(airlinePrice) === Math.round(highlightPrice) ? (
						<span className="tag">
							Disponível <span>AQUI</span>
						</span>
					) : (
						<span className={`tag ${!savings ? "hidden" : ""}`}>
							Economize <span>{savings}%</span>
						</span>
					)}
				</div>
			</div>
		);
	}

	showResume(key) {
		if (!this.state.showFlightDetails) return this.renderFlightStretch(key);
	}

	renderFlightStretch(key) {
		return (
			<FlightStretch
				flightdata={this.props.flightdata}
				showFlightDetails={true}
				showStops={true}
				tripdata={{
					from: this.props.flightdata.from,
					to: this.props.flightdata.to,
					departureDate: this.props.flightdata.departureDate,
					arrivalDate: this.props.flightdata.arrivalDate,
					duration: this.props.flightdata.duration,
					flightNumber: this.props.flightdata.flightNumber
				}}
				onGetDetails={this.toggleFlightDetails.bind(this)}
				shown={this.state.showFlightDetails}
				key={key}
			/>
		);
	}

	renderFlightDetails() {
		if (this.state.showFlightDetails) {
			if (
				this.props.flightdata.airline === "starAlliance" &&
				this.props.flightdata.pricing.mmBestPriceAt === "miles" &&
				(this.props.flightdata.pricing.miles.provider === "amigo" ||
					this.props.flightdata.pricing.miles.provider === "star_alliance") &&
				this.props.flightdata.updated !== true
			) {
				return (
					<div className="flight-stretch-group">
						{this.renderFlightStretch(Math.random())}
						<i className="loader loader-fetching" />
					</div>
				);
			}

			if (
				this.props.flightdata.airline === "starAlliance" &&
				this.props.flightdata.pricing.mmBestPriceAt === "miles" &&
				(this.props.flightdata.pricing.miles.provider === "amigo" ||
					this.props.flightdata.pricing.miles.provider === "star_alliance") &&
				this.props.flightdata.updated === true &&
				this.props.flightdata.trips[0].carrier === undefined
			) {
				return (
					<div className="flight-stretch-group">
						{this.renderFlightStretch(Math.random())}
						<p>
							Ops! Não foi possível carregar as informações sobre este voo. Tente atualizar esta
							página ou reinicie sua busca.
						</p>
					</div>
				);
			}

			return this.props.flightdata.trips.map((trip, index, trips) => {
				const nextTrip = trips[index + 1] ? trips[index + 1] : "lastTrip";
				const changeAirport = nextTrip !== "lastTrip" && trip.to !== nextTrip.from;

				return (
					<div className="flight-stretch-group" key={index}>
						<FlightStretch
							tripdata={trip}
							flightdata={this.props.flightdata}
							showFlightDetails={index == 0}
							onGetDetails={this.toggleFlightDetails.bind(this)}
							nexttripfrom={nextTrip.from}
							airportchange={changeAirport}
							shown={this.state.showFlightDetails}
							canUnselectFlight={this.props.isSelectedFlight && index == 0}
							key={Math.random() + index}
						/>

						{this.props.flightdata.stops !== "direct" && (
							<div className="flight-item-details">
								<ul className="list-inline">
									<li className="small">
										<strong>Classe deste trecho:</strong>{" "}
										{defineFlightCabin(
											trip,
											this.props.flightdata.airline,
											this.props.flightdata.pricing.mmBestPriceAt === "ota"
										)}
									</li>
									{trip.carrier &&
										trip.carrier !== "" && (
											<li className="small">
												<strong>Operado por:</strong> {trip.carrier}
											</li>
										)}
								</ul>
							</div>
						)}

						<FlightsInterval
							flightdata={trip}
							airportchange={changeAirport}
							nexttripfrom={nextTrip.from}
							position={this.props.position}
						/>
					</div>
				);
			});
		}
	}

	showDetailsButton() {
		if (this.props.isSelectedFlight) {
			return (
				<div className="flight-stretch-details">
					<a
						data-action="flight-stretch-details"
						onClick={e => {
							e.preventDefault();
							this.props.unselectFlight(this.props.flightdata);
						}}
						title="Escolher outro voo"
						className="btn btn-outline btn-xs"
					>
						<i className="icon-close" />
						Escolher outro voo
					</a>
				</div>
			);
		} else {
			return (
				<div className="flight-stretch-details">
					<a
						href=""
						title="Detalhes do voo"
						data-action="flight-stretch-details"
						onClick={event => {
							this.toggleFlightDetails(event);
						}}
						className="btn btn-outline btn-xs"
					>
						{this.state.showFlightDetails ? (
							<i className="icon-reduction" />
						) : (
							<i className="icon-addition" />
						)}
						Detalhes do voo
					</a>
				</div>
			);
		}
	}

	luggageInformation() {
		if (this.props.flightdata.otaAvailableIn !== "airline") {
			const maxPricing = bestMaxMilhasPrice(this.props.flightdata.pricing);

			return isValid(maxPricing) &&
				isValid(maxPricing.luggage) &&
				isValid(maxPricing.luggage.carryOn) &&
				isValid(maxPricing.luggage.carryOn.weight) &&
				isValid(maxPricing.luggage.checked)
				? maxPricing.luggage
				: null;
		}

		return null;
	}

	renderPrice() {
		return (
			<div className="col-xs-16 col-md-4 v-center-columns flight-item-price">
				{this.renderCiaPrice()}
				{this.renderHighlightPrice()}
			</div>
		);
	}

	checkHasPromotion() {
		const { pricing } = this.props.flightdata;
		return pricing.hasOwnProperty("promotion");
	}

	render() {
		const isOTA =
			this.props.flightdata.otaAvailableIn !== "airline" &&
			this.props.flightdata.pricing.mmBestPriceAt === "ota";
		return (
			<div
				className={`flight-item ${isOTA ? "flight-ota" : ""} ${
					this.props.isSelectedFlight ? "selected-flight" : ""
				}`}
			>
				<div className="container-fluid">
					<div className="row flex-row">
						<div className={`col-xs-16 col-md-12 v-center-columns flight-item-information luggage-info ${this.state.showFlightDetails ? "is-open" : ""}` }>
                            {this.state.showFlightDetails
                            && this.props.searchParams.cabin === "EX"
                            && this.props.isInternational
                            && this.props.flightdata.airline !== "gol"
                            && this.props.flightdata.pricing.mmBestPriceAt === "miles" && (
                                <div className="alert alert-info" role="alert">
                                    <div className="alert--icon">
                                        <i className="icon-exclamation" />
                                    </div>
                                    <div className="alert--message">
                                        <p>Existe a possibilidade de algum(s) do(s) trecho(s) ser(em) na <strong>classe ecônomica</strong>. Favor confirmar na Cia aérea.</p>
                                    </div>
                                </div>
                            )}
							{this.showResume(Math.random())}
							{this.renderFlightDetails()}
							<DispatchLuggage
								key={this.props.childId}
								childId={this.props.childId}
								lugagge={this.luggageInformation()}
								airline={this.props.flightdata.airline}
							/>

							{this.showFlightResume(Math.random())}

							{this.showDetailsButton()}
						</div>
						{this.checkHasPromotion() ? (
							<PriceCampaing flightdata={this.props.flightdata} />
						) : (
							this.renderPrice()
						)}
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	searchId: state.searchStatus.searchId,
	searchParams: state.searchParams.params,
	isInternational: state.searchStatus.isInternational,
	selectedFlights: state.selectedFlights
});

const mapDispatchToProps = dispatch => ({
	selectFlight: (flightdata, searchId, selectedFlights) => {
		dispatch(selectFlight(flightdata, searchId, selectedFlights));
	},
	unselectFlight: flightdata => {
		dispatch(unselectFlight(flightdata));
	},
	getFlightDetail: (flightIDs, searchIntentionID, selectedFlights, flightDirection) => {
		dispatch(getFlightDetails(flightIDs, searchIntentionID, selectedFlights, flightDirection));
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(FlightRow);
